import { isArray } from 'util';
import { Origin } from '../origin';

export class OriginBuilder {
  static fromJson(json) {
    return (json)
      ? new Origin(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OriginBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/origin.builder.ts